module.exports = __webpack_public_path__ + "img/case_10.4d8c2a04.png";